import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { CMSApiBase } from 'api/cms/base';
import { buildCmsUrl, getResponseCMS } from 'api/cms/base';
import type { IFAQ, IHowToParticipate } from 'api/cms/cloverGoldPromo';

export interface ICMSPumpkinRush extends CMSApiBase {
  howToParticipate: IHowToParticipate[];
  faq: IFAQ[];
}

export const pumpkinRush = factory(
  (r) => (lang: string) =>
    r<ICMSPumpkinRush>(
      'get',
      buildCmsUrl({
        path: 'pumpkin-rush',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);
